import EcoImg from 'eco-design/base/eco-img';
import { useOnceInView } from '../useOnceInView';
import css from './index.module.scss';
import { useLang } from '@/i18n';

function TheComp() {
    const { t } = useLang('theProduct');

    useOnceInView('.on-the-road-H .H-title', () => {
        document.querySelector('.on-the-road-H .H-title')?.classList.add('enter');
    });
    return (
        <section
            className={`${css.section} on-the-road-H GtmModuleData-section`}
            id="on-the-road-H"
            data-section-id={'on-the-road-H'}
            data-section-title={t('H_title')}
        >
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1767840241448-4lju4w-compressed-full-width-carousel.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1769482781634/bg.jpg"
                isOpenLazy
            />
            <div className="H-title ani-1">{t('H_title')}</div>
        </section>
    );
}

export default TheComp;
